/* ============================================================
   SHAPIFY THEME JS — cart drawer, quick add, hero slideshow
   Instant (optimistic) cart updates with exact product data.
   ============================================================ */
(function () {
  'use strict';

  var Shapify = (window.Shapify = window.Shapify || {});

  function formatMoney(cents) {
    var currency = Shapify.currency || 'INR';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency,
        maximumFractionDigits: (cents % 100 === 0 ? 0 : 2)
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function setAppHeight() {
    var h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--app-height', h + 'px');
  }
  setAppHeight();
  window.addEventListener('resize', setAppHeight);
  window.addEventListener('orientationchange', setAppHeight);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', setAppHeight);

  function drawer() { return document.getElementById('CartDrawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    setAppHeight();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
  Shapify.openCart = openDrawer;
  Shapify.closeCart = closeDrawer;

  function menuEl() { return document.getElementById('MenuDrawer'); }
  function openMenu() {
    var m = menuEl(); if (!m) return;
    setAppHeight();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeMenu() {
    var m = menuEl(); if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
  Shapify.openMenu = openMenu;
  Shapify.closeMenu = closeMenu;

  function searchModal() { return document.getElementById('SearchModal'); }
  function openSearch() {
    var s = searchModal(); if (!s) return;
    s.classList.add('is-open');
    s.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var input = s.querySelector('[data-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }
  function closeSearch() {
    var s = searchModal(); if (!s) return;
    s.classList.remove('is-open');
    s.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
  Shapify.openSearch = openSearch;
  Shapify.closeSearch = closeSearch;

  function runPredictive(q, results) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var products = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!products.length) {
          results.innerHTML = '<p class="search-modal__empty">No products found for "' + q + '".</p>';
          return;
        }
        var html = '<div class="search-modal__grid">';
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
          var price = '';
          var n = Number(p.price);
          if (p.price != null && isFinite(n)) {
            try {
              price = new Intl.NumberFormat(undefined, {
                style: 'currency', currency: Shapify.currency || 'INR',
                maximumFractionDigits: (n % 1 === 0 ? 0 : 2)
              }).format(n);
            } catch (e) { price = '' + n; }
          }
          html += '<a class="search-card" href="' + p.url + '">' +
            '<div class="search-card__media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="search-card__name">' + p.title + '</div>' +
            (price ? '<div class="search-card__price">' + price + '</div>' : '') +
            '</a>';
        });
        html += '</div>';
        html += '<a class="search-modal__all" href="/search?q=' + encodeURIComponent(q) + '">See all results &rsaquo;</a>';
        results.innerHTML = html;
      })
      .catch(function () { results.innerHTML = ''; });
  }

  function initSearch() {
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    if (!input || !results) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () { runPredictive(q, results); }, 250);
    });
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var empty = document.querySelector('[data-cart-empty]');
    if (!body) return;
    updateCount(cart.item_count);
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '';
      if (foot) foot.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    var html = '';
    cart.items.forEach(function (item, idx) {
      var rawImg = item.image;
      var src = rawImg;
      if (rawImg && rawImg.indexOf('width=') === -1 && !/_\d+x/.test(rawImg)) {
        src = rawImg.replace(/(\.[^.\/]+)(\?.*)?$/, '_160x$1$2');
      }
      var img = rawImg ? '<img src="' + src + '" alt="">' : '<div class="cd-item__img"></div>';
      var variant = item.product_has_only_default_variant ? '' :
        '<div class="cd-item__variant">' + (item.variant_title || '') + '</div>';
      html +=
        '<div class="cd-item" data-line="' + (idx + 1) + '">' +
          '<div class="cd-item__media">' + img + '</div>' +
          '<div class="cd-item__info">' +
            '<div class="cd-item__top">' +
              '<a class="cd-item__name" href="' + item.url + '">' + item.product_title + '</a>' +
              '<button class="cd-item__remove" data-remove="' + (idx + 1) + '" aria-label="Remove">&times;</button>' +
            '</div>' +
            variant +
            '<div class="cd-item__bottom">' +
              '<div class="cd-qty">' +
                '<button data-dec="' + (idx + 1) + '" aria-label="Decrease">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button data-inc="' + (idx + 1) + '" aria-label="Increase">+</button>' +
              '</div>' +
              '<span class="cd-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    body.innerHTML = html;
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  function updateCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
  }

  function fetchCart() {
    return fetch(Shapify.cartUrl ? Shapify.cartUrl + '.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function refresh() {
    return fetchCart().then(function (c) { Shapify._cart = c; renderCart(c); return c; });
  }

  function parsePrice(txt) {
    var r = parseFloat(String(txt || '').replace(/[^0-9.]/g, '')) || 0;
    return Math.round(r * 100);
  }
  function getAddData(el) {
    var priceAttr = (el && el.getAttribute) ? (el.getAttribute('data-add-price') || el.getAttribute('data-price')) : null;
    var priceCents = (priceAttr != null && priceAttr !== '') ? parseInt(priceAttr, 10) : null;
    var card = (el && el.closest) ? el.closest('.pcard, .reel-card') : null;
    if (card) {
      var nameEl = card.querySelector('.pcard__name, .reel-card__name');
      var imgEl = card.querySelector('.pcard__media img, .reel img');
      var priceEl = card.querySelector('.pcard__price, .reel-card__price');
      var linkEl = card.querySelector('a[href]');
      return {
        product_title: nameEl ? nameEl.textContent.trim() : 'Item',
        image: imgEl ? (imgEl.currentSrc || imgEl.src) : null,
        price: (priceCents != null ? priceCents : parsePrice(priceEl ? priceEl.textContent : '')),
        variant_title: '', default_variant: true,
        url: linkEl ? linkEl.getAttribute('href') : '#'
      };
    }
    var titleEl = document.querySelector('.pdp__title, .pdp h1');
    if (titleEl) {
      var pImg = document.getElementById('pdpMainImage');
      var pPrice = document.querySelector('.pdp__price[data-price]');
      var sel = document.getElementById('variantSelect');
      var vTitle = '', hasDefault = true;
      if (sel && sel.options.length > 1) {
        var opt = sel.options[sel.selectedIndex];
        vTitle = opt ? opt.textContent.trim() : '';
        hasDefault = false;
      }
      return {
        product_title: titleEl.textContent.trim(),
        image: pImg ? (pImg.currentSrc || pImg.src) : null,
        price: (priceCents != null ? priceCents : parsePrice(pPrice ? pPrice.textContent : '')),
        variant_title: vTitle, default_variant: hasDefault,
        url: window.location.pathname
      };
    }
    return null;
  }

  function addToCart(id, qty, btn, data) {
    qty = parseInt(qty, 10) || 1;
    openDrawer();
    flashAdded(btn);

    var cart = Shapify._cart;
    if (cart && cart.items) {
      var found = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].id) === String(id)) { found = cart.items[i]; break; }
      }
      if (found) {
        found.quantity += qty;
        found.final_line_price = (found.final_price || 0) * found.quantity;
        cart.item_count += qty;
        cart.total_price += (found.final_price || 0) * qty;
      } else {
        var d = data || {};
        var price = d.price || 0;
        cart.items.unshift({
          id: id, quantity: qty,
          product_title: d.product_title || 'Item',
          variant_title: d.variant_title || '',
          product_has_only_default_variant: d.default_variant !== false,
          image: d.image || null,
          url: d.url || '#',
          final_price: price,
          final_line_price: price * qty
        });
        cart.item_count += qty;
        cart.total_price += price * qty;
      }
      renderCart(cart);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
      .then(function () { return refresh(); })
      .catch(function (err) { refresh(); alert((err && err.description) || 'Could not add to cart.'); });
  }
  Shapify.addToCart = addToCart;

  function flashAdded(btn) {
    if (!btn) return;
    var label = btn.querySelector('.pcard__add-label, .pdp__add-text');
    btn.classList.add('is-added');
    if (label) {
      if (!label.dataset.orig) label.dataset.orig = label.textContent;
      label.textContent = 'Added ✓';
    } else {
      if (!btn.dataset.orig) btn.dataset.orig = btn.textContent;
      btn.textContent = 'Added ✓';
    }
    setTimeout(function () {
      btn.classList.remove('is-added');
      if (label && label.dataset.orig) label.textContent = label.dataset.orig;
      else if (btn.dataset.orig) btn.textContent = btn.dataset.orig;
    }, 1600);
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { Shapify._cart = c; renderCart(c); return c; });
  }

  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      var vid = qa.getAttribute('data-variant-id');
      if (vid) addToCart(vid, 1, qa, getAddData(qa));
      return;
    }
    var navPrev = e.target.closest('[data-slider-prev]');
    var navNext = e.target.closest('[data-slider-next]');
    if (navPrev || navNext) {
      var wrap = (navPrev || navNext).closest('.slider-wrap');
      var slider = wrap && wrap.querySelector('[data-slider]');
      if (slider) {
        var firstCard = slider.firstElementChild;
        var step = firstCard ? firstCard.getBoundingClientRect().width + 22 : 320;
        slider.scrollBy({ left: navPrev ? -step : step, behavior: 'smooth' });
      }
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); refresh(); return; }
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (e.target.closest('[data-menu-close]')) { closeMenu(); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); closeMenu(); openSearch(); return; }
    if (e.target.closest('[data-search-close]')) { closeSearch(); return; }
    var inc = e.target.closest('[data-inc]');
    if (inc) { var li = +inc.getAttribute('data-inc'); bump(li, 1); return; }
    var dec = e.target.closest('[data-dec]');
    if (dec) { var ld = +dec.getAttribute('data-dec'); bump(ld, -1); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { removeLine(+rm.getAttribute('data-remove')); return; }
    var acc = e.target.closest('[data-accordion-toggle]');
    if (acc) {
      var item = acc.closest('[data-accordion-item]');
      if (item) item.classList.toggle('is-open');
    }
  });

  function bump(line, delta) {
    var cart = Shapify._cart;
    var it = (cart && cart.items) ? cart.items[line - 1] : null;
    var target;
    if (it) {
      target = Math.max(0, it.quantity + delta);
      var diff = target - it.quantity;
      cart.item_count += diff;
      cart.total_price += (it.final_price || 0) * diff;
      if (target === 0) { cart.items.splice(line - 1, 1); }
      else { it.quantity = target; it.final_line_price = (it.final_price || 0) * target; }
      renderCart(cart);
    } else {
      var span = document.querySelector('[data-line="' + line + '"] .cd-qty span');
      target = Math.max(0, (span ? parseInt(span.textContent, 10) : 1) + delta);
    }
    changeLine(line, target);
  }

  function removeLine(line) {
    var cart = Shapify._cart;
    var it = (cart && cart.items) ? cart.items[line - 1] : null;
    if (it) {
      cart.item_count -= it.quantity;
      cart.total_price -= (it.final_price || 0) * it.quantity;
      cart.items.splice(line - 1, 1);
      renderCart(cart);
    }
    changeLine(line, 0);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); closeSearch(); }
  });

  function bindProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.__bound) return;
      form.__bound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var data = new FormData(form);
        var id = data.get('id');
        var qty = data.get('quantity') || 1;
        var btn = form.querySelector('[type="submit"]');
        addToCart(id, qty, btn, getAddData(btn));
      });
    });
  }

  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (sw) {
      var slides = sw.querySelectorAll('[data-slide]');
      var scope = sw.closest('section') || sw.parentElement;
      var dots = scope.querySelectorAll('[data-dot]');
      if (slides.length < 2) { return; }
      var i = 0;
      var speed = parseInt(sw.getAttribute('data-speed'), 10) || 4000;
      var timer;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      }
      function next() { show(i + 1); }
      function start() { stop(); timer = setInterval(next, speed); }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(+d.getAttribute('data-dot')); start(); });
      });
      var prevBtn = scope.querySelector('[data-slide-prev]');
      var nextBtn = scope.querySelector('[data-slide-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(i - 1); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(i + 1); start(); });
      sw.addEventListener('mouseenter', stop);
      sw.addEventListener('mouseleave', start);
      start();
    });
  }

  function markCurrent(container) {
    var isMobile = window.matchMedia('(max-width:900px)').matches;
    var kids = container.children;
    if (!isMobile) { for (var j = 0; j < kids.length; j++) kids[j].classList.remove('is-current'); return; }
    var crect = container.getBoundingClientRect();
    var anchor = crect.left + 32;
    var best = null, bestD = Infinity;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      var d = Math.abs(r.left - anchor);
      if (d < bestD) { bestD = d; best = kids[i]; }
    }
    for (var k = 0; k < kids.length; k++) { kids[k].classList.toggle('is-current', kids[k] === best); }
  }
  function initCarouselHighlight() {
    var containers = document.querySelectorAll('.pgrid--carousel, .reels--slider');
    containers.forEach(function (c) {
      var raf;
      function onScroll() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { markCurrent(c); }); }
      c.addEventListener('scroll', onScroll, { passive: true });
      markCurrent(c);
    });
    window.addEventListener('resize', function () { containers.forEach(markCurrent); });
  }

  function init() {
    bindProductForms();
    initSlideshows();
    initCarouselHighlight();
    initSearch();
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
